import { filterClasses } from "@swivl-mono/helpers";
import { LocationVarInheritance } from "@swivl-mono/types";

const LABELS: Record<LocationVarInheritance, string> = {
  [LocationVarInheritance.NONE]: "Customized",
  [LocationVarInheritance.GROUP]: "From Group",
  [LocationVarInheritance.ORG]: "From Org",
  [LocationVarInheritance.DEFAULT]: "Default"
};

const CLASSES: Record<LocationVarInheritance, string> = {
  [LocationVarInheritance.NONE]: "bg-orange-50 text-orange-600",
  [LocationVarInheritance.GROUP]: "bg-purple-100 text-purple-700",
  [LocationVarInheritance.ORG]: "bg-teal-100 text-teal-700",
  [LocationVarInheritance.DEFAULT]: "bg-grey-100 text-grey-700"
};

interface CortexInheritancePillProps {
  inheritance: LocationVarInheritance;
  /**
   * Override the wording while keeping the tag's styling. For callers whose
   * cascade doesn't match the Cortex vocabulary — the Hours page has no default
   * tier beneath org, so an org row is the baseline rather than a customization.
   */
  label?: string;
}

export function CortexInheritancePill({ inheritance, label }: CortexInheritancePillProps): React.ReactElement {
  return <span className={filterClasses("body-xs rounded-xs px-1 py-0.5", CLASSES[inheritance])}>{label ?? LABELS[inheritance]}</span>;
}
